<div class="modal-body">
  <div id="modal-header-wrapper">
    <h2 id="title-text">{{ title }}</h2>
    <p *ngIf="subtitle" id="subtitle-text" [innerHTML]="subtitle"></p>
  </div>
  <div class="modal-footer">
    <button id="cancel-button" (click)="hideModal(); cancel.emit();" type="button"
      class="btn btn-outline-primary btn-outline text-only">
      {{ cancelLabel ?? 'Annuler' }}
    </button>

    <button id="validate-button" (click)="hideModal(); validate.emit()" type="button" class="btn btn-primary btn-gradient">
      {{ validateLabel ?? 'Valider' }}
    </button>
  </div>
</div>
